"use client";
import { SchoolData } from "@nimble/candidate-api/types";
import * as React from "react";

import { AcceptMatchFormContainer } from "@/app/(discover)/candidate/invites/components/accept-match-modal/accept-match-form";
import { AcceptMatchModalView } from "@/app/(discover)/candidate/invites/components/accept-match-modal/accept-match-view";
import { MatchAcceptedSource } from "@/lib/posthog/track";

export default function AcceptMatchModal({
  onClose,
  onSubmitSuccess,
  schoolData,
  source,
}: {
  onClose: () => void;
  onSubmitSuccess: () => void;
  schoolData: SchoolData;
  source: MatchAcceptedSource;
}) {
  return (
    <AcceptMatchModalView
      onClose={onClose}
      schoolData={schoolData}
      formEl={
        <AcceptMatchFormContainer
          onSubmitSuccess={onSubmitSuccess}
          onCancel={onClose}
          schoolNcesId={schoolData.nces_id}
          schoolName={schoolData.name}
          source={source}
        />
      }
    />
  );
}
